import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Drawer from '@material-ui/core/Drawer';
import { Box, Divider } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { useMinWidth } from '../../hooks/useResize';
import { sizes } from '../../styles/variables';
import { LogoWrapper } from '../Header/styled/LogoWrapper';
import useStyles from './styled/SidebarStyles';
import Logo from '../Header/Logo';
import WorkspaceName from './WorkspaceName';
import HospitalSwitcher, { PatientSwitcher } from './Switcher';
import Menu from './Menu';
import { getUserInterface } from '../../utils/ApplicationInterfaceUtils';
import {
  hospitalMenuOptions,
  providerMenuOptions,
  hospitalSettingsMenuOptions,
  userSettingsMenuOptions,
  userPatientSettingsMenuOptions,
  patientMenuOptions,
} from './MenuOptions';
import PinSidebar from './PinSidebar';

export default ({
  type,
  handleDrawerToggle,
  visibleSidebar,
  fixSidebar,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = useStyles();
  const isMinWidth = useMinWidth(sizes.mdMin);
  const ui = getUserInterface();

  if (type === 'new') return null;

  const getMenuOptions = () => {
    const option = `${ui}|${type}`;
    switch (option) {
      case 'doctor|provider':
        return providerMenuOptions;
      case 'doctor|settings':
        return hospitalSettingsMenuOptions;
      case 'doctor|userSettings':
        return userSettingsMenuOptions;
      case 'patient|userSettings':
        return userPatientSettingsMenuOptions;
      case 'patient|undefined':
        return patientMenuOptions;
      default:
        return hospitalMenuOptions;
    }
  };
  const Switcher = ui === 'patient' ? PatientSwitcher : HospitalSwitcher;
  const navClass = (fixSidebar && !isMinWidth) ? classes.drawer : classes.noDrawer;

  const showSidebarIcon = () => dispatch({ type: 'TOGGLE_PIN_SIDEBAR_ICON', pinSidebarIcon: { pinSidebarIcon: true } });
  const hideSidebarIcon = () => dispatch({ type: 'TOGGLE_PIN_SIDEBAR_ICON', pinSidebarIcon: { pinSidebarIcon: false } });

  return (
    <Box
      onMouseEnter={showSidebarIcon}
      onMouseLeave={hideSidebarIcon}
    >
      <nav className={navClass}>
        <Drawer
          variant={(fixSidebar && !isMinWidth) ? 'permanent' : 'temporary'}
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={visibleSidebar}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div className={classes.separator} />
          {type === 'userSettings' ? (
            <div className={classes.userData}>
              <span>{t('user.data')}</span>
            </div>
          ) : (
            <>
              <LogoWrapper>
                <Logo />
              </LogoWrapper>
              {type === 'settings'
                ? <WorkspaceName type={type} py-6 px-9 pb-0 />
                : <Switcher type={type} />}
            </>
          )}
          <Divider color="primary" />
          <Menu fixSidebar={fixSidebar} options={getMenuOptions()} />
        </Drawer>
      </nav>
      {!isMinWidth && <PinSidebar/>}
    </Box>
  );
};
